import { SyntheticEvent, useState } from 'react';

export const useModal = <T = unknown>() => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setContent] = useState<T | null | undefined>(null);

  const openModal = (e?: SyntheticEvent | null, content?: T | null) => {
    e?.stopPropagation();
    setIsModalOpen(true);
    setContent(content);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setContent(null);
  };

  return { isModalOpen, openModal, closeModal, modalContent };
};
